<template>

    <v-page-section padded>
        <template #title>Latest Invoices</template>
        <template #body>
            <v-table bordered>
                <thead>
                    <th><div class="label">Date</div></th>
                    <th><div class="label">Amount</div></th>
                    <th></th>
                </thead>
                <tbody>
                    <tr v-for="invoice in invoices" :key="invoice.id" @click="open(invoice.invoice_pdf)">
                        <td>{{ invoice.created_at | date }}</td>
                        <td>{{ invoice.amount_due / 100 | currency }}</td>
                        <td>
                            <v-button-toolbar class="float-right" size="sm">
                                <v-button size="xs" btn-style="secondary" @click.native="open(invoice.invoice_url)">View</v-button>
                                <v-button size="xs" @click.native="open(invoice.invoice_pdf)">PDF</v-button>
                            </v-button-toolbar>
                        </td>
                    </tr>
                </tbody>
            </v-table>
        </template>
    </v-page-section>

</template>

<script>

export default {

    props: {
        invoices: {
            type: Array,
            required: true,
        },
    },

    methods: {

        open(url) {
            window.open(url, '_blank');
        },

    },

}

</script>